import React, { useState } from 'react';
import { HiBell } from 'react-icons/hi';
import { HiDocumentText, HiTable } from 'react-icons/hi';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header = ({ currentPage = 'form', onPageChange }) => {
  const { user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getInitials = () => {
    if (!user) return 'U';
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    if (firstName && lastName) {
      return (firstName[0] + lastName[0]).toUpperCase();
    }
    if (firstName) {
      return firstName[0].toUpperCase();
    }
    if (user.username) {
      return user.username[0].toUpperCase();
    }
    return 'U';
  };

  const handleNavClick = (page) => {
    onPageChange(page);
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-content">
        <button 
          className="menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <div className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
        
        <h1 className="header-title">Учет расходов</h1>
        
        <div className="header-right">
          <button className="notification-button">
            <HiBell className="bell-icon" />
          </button>
          <button className="profile-button">
            <div className="profile-avatar">
              {user?.photoUrl ? (
                <img 
                  src={user.photoUrl} 
                  alt="Profile" 
                  className="profile-image"
                />
              ) : (
                <span className="profile-initial">{getInitials()}</span>
              )}
            </div>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <>
          <div className="menu-overlay" onClick={() => setIsMenuOpen(false)}></div>
          <div className="burger-menu">
            <button
              className={`menu-item ${currentPage === 'form' ? 'active' : ''}`}
              onClick={() => handleNavClick('form')}
            >
              <HiDocumentText className="menu-icon" />
              <span className="menu-label">Форма</span>
            </button>
            <button
              className={`menu-item ${currentPage === 'table' ? 'active' : ''}`}
              onClick={() => handleNavClick('table')}
            >
              <HiTable className="menu-icon" />
              <span className="menu-label">Таблицы</span>
            </button>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
